import cssVars from 'css-vars-ponyfill'
import {
  getCSSVars,
  isElementInViewport,
  numberWithCommas,
} from '../util/functional'
import Navigation from './navigation'
import Global from './global'
import { CountUp } from 'countup.js'
import AOS from 'aos'
import 'select2'
import datepicker from 'js-datepicker'
import Sticky from 'sticky-js'
import 'jquery.marquee'

// import GMap from './gmap'

export default {
  sticky: new Sticky('.sticky', {
    marginTop: $('.header').height(),
  }),
  init() {
    AOS.init({ duration: 700, disable: 'phone' })
    Navigation.init()
    this.toggleLogo()
    this.setCSSVars()
    this.openModals()
    this.counterInit()
    this.formFields()
    this.formThankYou()
    this.heroVideoHandler()
    this.playVideo()
    this.videoAutoInit()
    this.marqueeTextScroll()
    // this.cptSliderInit()
    this.testimonialsSlider()
    this.partnersSlider()
    this.iconBlockSlider()
    this.scrollspyEvents()
    this.initDivisionsTabsSlider()
    this.initDropdownMenu()
    this.featuredPostsSlider()

    const answerLists = $('.js-answer-list')
    if (answerLists.length) {
      answerLists.each((index, el) => {
        const $slider = $(el)
        this.mobileSliderInit(
          $slider,
          {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            focusOnSelect: true,
            swipeToSlide: true,
          },
          'md'
        )
      })
    }

    const postsInterested = $('.js-posts-interested')
    if (postsInterested.length) {
      postsInterested.each((index, el) => {
        const $slider = $(el)
        this.mobileSliderInit(
          $slider,
          {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            focusOnSelect: true,
            swipeToSlide: true,
            infinite: false,
            responsive: [
              {
                breakpoint: parseInt(getCSSVars('--bp-md')) - 1,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ],
          },
          'lg'
        )
      })
    }

    // GMap.init()
    this.onResize()

    setTimeout(() => {
      this.resizeVideo()
    }, 100)

    $(
      'a[href^="#"]:not([href="#"],[href^="#fancy-"],[href^="#collapse-"],[href^="#tabs-"],[role="tab"],[data-vc-accordion]), a[href^="' +
        location.origin +
        location.pathname +
        '#"]'
    ).on('click', e => {
      this.smoothScroll($(e.currentTarget).attr('href'), e)
    })
    if (window.location.hash && $(window.location.hash).length) {
      this.smoothScroll(window.location.hash)
    }
  },
  openModals() {
    $('body').on('click', 'a[href^="#modal-"]', function () {
      const modalId = $(this).attr('href').split('#modal-').pop()
      const $modal = $(`#${modalId}`)
      if ($modal.length) {
        $modal.modal('show')
        Global.htmlFixed()

        $modal.off('hidden.bs.modal').on('hidden.bs.modal', () => {
          Global.htmlFixed()
        })
      }
    })

    $('body').on('click', '.btn-close', function () {
      const $modal = $(this).closest('.modal')
      if ($modal.length) {
        $modal.modal('hide')
      }
    })
  },
  toggleLogo() {
    const heroPlaceholder = document.querySelector('.js-hero-iv__placeholder')
    if (heroPlaceholder) {
      const logo = document.querySelector('.header .navbar-brand')
      const header = document.querySelector('.header')
      $(window).scroll(() => {
        const heroTop =
          heroPlaceholder.getBoundingClientRect().bottom - header.offsetHeight
        const windowTop = 0

        if (heroTop <= windowTop) {
          logo.classList.remove('navbar-brand--invisible')
        } else {
          logo.classList.add('navbar-brand--invisible')
        }
      })
    }
  },
  setCSSVars() {
    cssVars({
      variables: {
        '--body-width': document.body.clientWidth + 'px',
      },
    })
  },
  playVideo() {
    $('body').on('click', '.js-play-btn', function () {
      const $btn = $(this)
      const $wrapper = $btn.closest('.js-video-wrapper')
      const $poster = $wrapper.find('.js-video-poster')
      const $video = $wrapper.find('video')
      const $iframe = $wrapper.find('iframe')

      $poster.fadeOut()
      $btn.fadeOut()
      if ($video.length) {
        $video.fadeIn().get(0).play()
      }

      if ($iframe.length) {
        $iframe.show().attr('src', $iframe.attr('src') + '&autoplay=1')
      }
    })
  },
  heroVideoHandler() {
    const video = document.getElementById('hero-video')
    if (video) {
      const videoButton = document.getElementById('hero-video-btn')
      const videoPlaceholder = document.getElementsByClassName(
        'hero-video__placeholder'
      )
      video.addEventListener(
        'ended',
        () => {
          videoButton.classList.remove('hide')
        },
        false
      )
      video.onclick = () => {
        if (video.paused) {
          video.play()
          videoButton.classList.add('hide')
          videoPlaceholder[0].classList.add('hide')
        } else {
          video.pause()
          videoButton.classList.remove('hide')
        }
        return false
      }
    }
  },
  marqueeTextScroll() {
    $('.marquee').marquee({
      duration: 9500,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
    })
  },
  smoothScroll(link, e) {
    if (
      link &&
      link.indexOf('#') > 0 &&
      link.split('#')[0].indexOf(location.origin + location.pathname) !== 0
    ) {
      return false
    }
    if (e) e.preventDefault()
    let hash = false
    if (!link && window.location.hash) {
      hash = window.location.hash
    } else if (link && link.indexOf('#') >= 0) {
      hash = '#' + link.split('#')[1]
    } else if (
      link &&
      location.pathname.replace(/^\//, '') ==
        link.pathname.replace(/^\//, '') &&
      location.hostname == link.hostname
    ) {
      hash = link.hash
    }
    if (hash && $(hash).length) {
      if (Global.htmlFixedState) {
        Navigation.menuToggle()
      }
      let additionalOffset = 0
      const scrollSpyBar = $('.section--scroll-bar #scrollspy-navbar')
      if (scrollSpyBar.length) {
        additionalOffset += scrollSpyBar.outerHeight()
      }

      const scrollTeamSpyBar = $('.section--team #scrollspy-navbar')
      if (scrollTeamSpyBar.length) {
        additionalOffset += 70
      }

      $('html, body').animate(
        {
          scrollTop:
            $(hash).offset().top -
            $('.js-main-header').outerHeight() -
            additionalOffset,
        },
        600
      )
      history.replaceState(null, null, hash)
    }
    $(window).trigger('hashchange')
  },
  counterInit() {
    const counters = $('.js-counter')
    if (counters.length) {
      $(window).on('load resize scroll', () => {
        counters.each(function () {
          if (isElementInViewport(this)) {
            if (!$(this).hasClass('counted')) {
              const countUp = new CountUp(this, $(this).data('end'), {
                useGrouping: true,
                // decimal: '.',
                // decimalPlaces: 2,
              })
              countUp.start()
              $(this).addClass('counted')
            }
          }
        })
      })
    }
  },
  cptSliderInit() {
    const $homeSlider = $('.js-cpt-slider')

    if ($homeSlider.length) {
      const postMessageToPlayer = (player, command) => {
        if (player == null || command == null) return
        player.contentWindow.postMessage(JSON.stringify(command), '*')
      }

      $homeSlider
        .on('init', function (event, slick) {
          slick.$slides
            .not(':eq(0)')
            .find('.video--local')
            .each(function () {
              this.pause()
            })

          if (slick.$slides.eq(0).find('.video--local').length) {
            slick.$slides.eq(0).find('.video--local')[0].play()
          }
          if (slick.$slides.eq(0).find('.video--embed').length) {
            var playerId = slick.$slides.eq(0).find('iframe').attr('id')
            var player = $('#' + playerId).get(0)
            postMessageToPlayer(player, {
              event: 'command',
              func: 'playVideo',
            })
          }
        })
        .on('beforeChange', function (event, slick, currentSlide) {
          // Pause youtube video on slide change
          if (slick.$slides.eq(currentSlide).find('.video--embed').length) {
            var playerId = slick.$slides
              .eq(currentSlide)
              .find('iframe')
              .attr('id')
            var player = $('#' + playerId).get(0)
            postMessageToPlayer(player, {
              event: 'command',
              func: 'pauseVideo',
            })
          }
          // Pause local video on slide change
          if (slick.$slides.eq(currentSlide).find('.video--local').length) {
            slick.$slides.eq(currentSlide).find('.video--local')[0].pause()
          }
        })
        .on('afterChange', function (event, slick, currentSlide) {
          // Start playing local video on current slide
          if (slick.$slides.eq(currentSlide).find('.video--local').length) {
            slick.$slides.eq(currentSlide).find('.video--local')[0].play()
          }

          // Start playing youtube video on current slide
          if (slick.$slides.eq(currentSlide).find('.video--embed').length) {
            var playerId = slick.$slides
              .eq(currentSlide)
              .find('iframe')
              .attr('id')
            var player = $('#' + playerId).get(0)
            postMessageToPlayer(player, {
              event: 'command',
              func: 'playVideo',
            })
          }
        })

      const autoplaySpeed = $homeSlider.data('autoplay-speed')
      $homeSlider.slick({
        ...Global.slickDefault,
        cssEase: 'ease',
        fade: true, // Cause trouble if used slidesToShow: more than one
        arrows: true,
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: Boolean($homeSlider.data('autoplay')),
        pauseOnHover: true,
        autoplaySpeed: autoplaySpeed ? autoplaySpeed * 1000 : 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        //slide: '.cpt-slider__item', // Cause trouble with responsive settings
      })
    }
  },
  testimonialsSlider() {
    const $slider = $('.js-testimonials-slider')

    if ($slider.length) {
      $slider.slick({
        ...Global.slickDefault,
        arrows: false,
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 3,
        slidesToScroll: 3,
        // centerMode: true,
        // centerPadding: 0,
        // focusOnSelect: true,
        // swipeToSlide: true,
        // adaptiveHeight: true,
        responsive: [
          {
            breakpoint: parseInt(getCSSVars('--bp-lg')) - 1,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: parseInt(getCSSVars('--bp-md')) - 1,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      })
    }
  },
  partnersSlider() {
    const $slider = $('.js-partners-slider')

    if ($slider.length) {
      $slider.slick({
        ...Global.slickDefault,
        arrows: false,
        dots: false,
        infinite: true,
        speed: 5000,
        autoplay: true,
        autoplaySpeed: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: 0,
        focusOnSelect: true,
        swipeToSlide: true,
        cssEase: 'linear',
        variableWidth: true,
      })
    }
  },
  iconBlockSlider() {
    const $slider = $('.js-icon-block-slider')

    if ($slider.length) {
      $slider.slick({
        nextArrow:
          '<button type="button" class="slick-next">' +
          '<svg width="37" height="17" viewBox="0 0 37 17" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M0 8.5H36M36 8.5L28.5 1M36 8.5L28.5 16" stroke="currentColor"/>' +
          '</svg></button>',
        prevArrow:
          '<button type="button" class="slick-prev">' +
          '<svg width="38" height="17" viewBox="0 0 38 17" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M37.0224 8.60758L1.02258 8.49998M1.02258 8.49998L8.50013 16.0224M1.02258 8.49998L8.54496 1.02243" stroke="currentColor"/>' +
          '</svg></button>',
        rows: 0, // Prevent generating extra markup
        arrows: true,
        dots: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        swipeToSlide: true,
        responsive: [
          {
            breakpoint: parseInt(getCSSVars('--bp-lg')) - 1,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: parseInt(getCSSVars('--bp-md')),
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      })
    }
  },
  initDivisionsTabsSlider() {
    const $sliders = $('.js-divisions-tabs')

    if ($sliders.length) {
      $sliders.each(function () {
        const $slider = $(this)
        const $section = $slider.closest('section')
        let autoplay = isElementInViewport($slider) ? true : false

        if (!$section.find('.divisions-nav-item__link').length) {
          $section.find('.divisions-nav-item').on('click', function () {
            $('html, body').animate({ scrollTop: $section.offset().top }, 1000)
            $section
              .find('.divisions-nav-slider')
              .removeClass('divisions-nav-slider-loaded')
            $slider.slick('slickSetOption', { autoplay: autoplay }, true)
          })
        }

        $(window).on('scroll', function () {
          let autoplay = isElementInViewport($slider) ? true : false
          $slider.slick('slickSetOption', { autoplay: autoplay }, true)
          $section
            .find('.divisions-nav-slider')
            .toggleClass('divisions-nav-slider-loaded', !autoplay)
        })

        const $sliderNav = $slider
          .closest('section')
          .find('.js-divisions-tabs-nav')

        if ($sliderNav.length) {
          $slider.slick({
            ...Global.slickDefault,
            arrows: false,
            dots: false,
            fade: true,
            autoplay: false,
            swipeToSlide: false,
            pauseOnHover: true,
            pauseOnFocus: true,
            infinite: true,
            asNavFor: $sliderNav,
          })

          $sliderNav
            .on('mouseover', () => {
              $slider.slick('slickSetOption', { autoplay: false }, true)
            })
            .slick({
              ...Global.slickDefault,
              arrows: false,
              dots: false,
              autoplay: false,
              slidesToShow: 4,
              slidesToScroll: 1,
              focusOnSelect: true,
              cssEase: 'linear',
              asNavFor: $slider,
              pauseOnHover: true,
              pauseOnFocus: true,
              infinite: false,
              responsive: [
                {
                  breakpoint: parseInt(getCSSVars('--bp-lg')) - 1,
                  settings: {
                    slidesToShow: 2,
                    centerMode: true,
                    centerPadding: '15%',
                    infinite: true,
                  },
                },
                {
                  breakpoint: parseInt(getCSSVars('--bp-sm')) - 1,
                  settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '25%',
                    infinite: true,
                  },
                },
              ],
            })
        }
      })
    }
  },
  mobileSliderInit($slider, args = {}, bp = 'sm') {
    const viewport = window.bootstrapToolkit
    $slider.each(function () {
      const slider = $(this)
      const sliderArgs = {
        ...Global.slickDefault,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        dots: true,
        arrows: false,
        ...args,
      }

      const sliderCheck = () => {
        if (viewport.is(`<${bp}`)) {
          if (!slider.hasClass('slick-initialized')) {
            slider.slick(sliderArgs)
          }
        } else {
          if (slider.hasClass('slick-initialized')) {
            slider.slick('unslick')
          }
        }
      }

      sliderCheck()

      $(window).resize(
        viewport.changed(function () {
          sliderCheck()
        })
      )
    })
  },
  formFields() {
    $('select').each(function () {
      var $this = $(this)

      $this.select2({
        minimumResultsForSearch: -1,
        placeholder: $this.data('placeholder'),
      })
    })

    $('input[type="date"]:not(.js-transaction-date)').each(function () {
      const el = this
      $(el).attr('type', 'text').attr('autocomplete', 'off')
      datepicker(el, {
        formatter: (input, date) => {
          input.value = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split('T')[0]
        },
      })
    })

    $('.js-amount').on('keyup', function () {
      const $this = $(this)
      let val = $this.val().replace(/[^0-9]/g, '')

      $this.val('$' + numberWithCommas(val))
    })
  },
  formThankYou() {
    document.addEventListener(
      'wpcf7mailsent',
      function (event) {
        const formWrapper = $(event.target).closest('.wpcf7')
        const thankYou = formWrapper.find('.js-thank-you')

        if (thankYou.length) {
          formWrapper.hide().after(thankYou.html())

          const downloadButton = formWrapper.find('.js-download-btn')
          if (downloadButton.length) {
            downloadButton[0].click()
          }
        }

        const redirectInput = formWrapper.find('[name="redirect"]')
        if (redirectInput.length) {
          const userEmail = formWrapper.find('[name="your-email"]')
          let getArgs = ''
          if (userEmail.length) {
            getArgs = '?ue=' + userEmail.val()
          }

          location = redirectInput.val() + getArgs
        }
      },
      false
    )
  },
  videoAutoInit() {
    const videoBtn = $('.js-video-auto')

    if (videoBtn.length) {
      videoBtn.on('click', function () {
        const $this = $(this)
        const video = $this.next('video')

        $this.hide()

        video[0].currentTime = '0'
        video
          .prop('muted', false)
          .prop('controls', true)
          .prop('autoplay', false)
          .prop('loop', false)
      })
    }
  },
  scrollspyEvents() {
    if ($('[data-spy="scroll"]').length) {
      $(window).on('activate.bs.scrollspy', function (e, obj) {
        const dropdownTitle = $('.js-dropdown-toggle')
        dropdownTitle.text(
          $('.dropdown-item[href="' + obj.relatedTarget + '"]').text()
        )
      })

      const stickySpy = $('.sticky-spy')

      const sticky = new Sticky('.sticky-spy', {
        marginTop: Navigation.viewport.is(`>md`)
          ? $('.js-main-header').outerHeight()
          : 48,
      })

      $(window).resize(
        Navigation.viewport.changed(() => {
          sticky.destroy()
          const section = stickySpy.closest('.section--scroll-bar')
          if (section.length) {
            section.html(stickySpy.detach())
          }

          new Sticky('.sticky-spy', {
            marginTop: Navigation.viewport.is(`>md`)
              ? $('.js-main-header').outerHeight()
              : 48,
          })
        })
      )
    }
  },
  resizeVideo() {
    const $holder = $('.js-video-wrapper')
    $holder.each(function () {
      const $videoWrapper = $(this)
      const width = 16
      const height = 9
      $videoWrapper.find('.videoHolder').each(function () {
        const $videoHolder = $(this)
        if (
          $videoWrapper.outerWidth() / width >
          $videoWrapper.outerHeight() / height
        ) {
          $videoHolder.css({
            width: '100%',
            height: 'auto',
          })
        } else {
          $videoHolder.css({
            width: ($videoWrapper.outerHeight() * width) / height,
            height: '100%',
          })
        }
      })
    })
  },
  onResize() {
    $(window).resize(() => {
      this.setCSSVars()
      setTimeout(() => {
        this.resizeVideo()
        this.sticky.update()
      }, 100)
    })
  },
  initDropdownMenu() {
    const $dropdown = $('.js-dropdown-menu')
    $dropdown.on('click', e => {
      if (window.innerWidth < parseInt(getCSSVars('--bp-lg'))) {
        let $listItem = $(e.target).closest('li')
        let $currentLink = $(e.target).closest('a')

        if (!$currentLink.length || $listItem.hasClass('is-current')) {
          e.preventDefault()

          if ($dropdown.hasClass('open')) {
            $dropdown.prepend($listItem)
          }

          $dropdown.toggleClass('open')
        }
      }
    })
  },
  featuredPostsSlider() {
    const $sliders = $('.js-featured-posts-slider')

    if ($sliders.length) {
      $sliders.slick({
        ...Global.slickDefault,
        arrows: true,
        dots: true,
        fade: true,
        infinite: true,
        adaptiveHeight: true,
      })
    }
  },
}
